import { gql, useQuery } from '@apollo/client';

export function useCategories() {
    return useQuery(gql`
    query getCategories {
        categories {
            _id
            description
            image
            level
            parent_id
        }
    }
  `);
}

export function useCategoriesEmpowerMe() {
    return useQuery(gql`
    query getCategoriesEmpowerMe {
        categories_empower_me {
            _id
            description
            image
            level
            parent_id
            color
        }
    }
  `);
}